import React from 'react'
import {
  CFImage,
  CFLink,
  CFSelect,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { locationMap, mobileMap } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect w="100%" selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView w="100%">
          <MobileScreen>
            <CFLink
              href="https://maps.app.goo.gl/seXEL9N6ubr8Bogr5"
              target="_blank"
            >
              <CFImage
                src={mobileMap}
                w="100%"
                alt="Blue Coast Japanese Seafood Cuisine Restaurant Map"
              />
            </CFLink>
          </MobileScreen>
          <DefaultScreen w="100%">
            <CFLink
              w="100%"
              href="https://maps.app.goo.gl/seXEL9N6ubr8Bogr5"
              target="_blank"
            >
              <CFImage
                src={locationMap}
                w="100%"
                alt="Blue Coast Japanese Seafood Cuisine Restaurant Kitchen Map"
              />
            </CFLink>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
